module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.HangSengLogoResized-e79aa830e67f6b7cffad928a352b40cd.png";